import {Component, Input, OnInit} from '@angular/core';
import {Document} from "../../../classes/document";
import {ActivatedRoute, Router} from "@angular/router";
import {DocumentService} from "../../../services/document";
import {tap} from "rxjs/operators";
import {mergeMap} from "rxjs";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {Inspection} from "../../../classes/inspection";

@Component({
  selector: 'app-inspection-document-upload',
  templateUrl: './inspection-document-upload.component.html',
  styleUrls: ['./inspection-document-upload.component.css']
})
export class InspectionDocumentUploadComponent implements OnInit {

  @Input() inspection!: Inspection;
  document = new Document();
  fileName = '';
  fileData = new FormData();
  inspectionDocumentUploadResult: boolean | undefined = undefined;

  constructor(private route: ActivatedRoute,
              private router: Router,
              public activeModal: NgbActiveModal,
              private documentService: DocumentService) { }

  ngOnInit(): void {
    this.document.fk_id_inspection = this.inspection.id_inspection!;
  }

  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      this.fileName = file.name;
      this.fileData.set('inspectionDocumentFile', file);
    }
  }

  onSubmit() {
    this.fileData.set('idInspection', (this.document.fk_id_inspection).toString());
    this.documentService.upload(this.fileData)
        .pipe(
            tap((fileInfo: any) => this.document.name = fileInfo.fileName),
            mergeMap(() => this.documentService.create(this.document))
        )
        .subscribe({
          next: () => {
            this.activeModal.close();
          },
          error: e => {
            this.inspectionDocumentUploadResult = false;
            console.log(e);
          }
        });
  }

}
